import React, { useEffect, useRef } from "react";
import h337 from "heatmap.js";

type Shot = {
  x: number; // en %
  y: number; // en %
};

type Props = {
  shots: Shot[];
};

export const ShotHeatmapCanvas = ({ shots }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    const img = imgRef.current;
    if (!container || !img) return;

    // Nettoyage précédent
    container.querySelectorAll("canvas").forEach((el) => el.remove());

    // Attendre que l'image soit bien chargée
    const onLoad = () => {
      const width = img.clientWidth;
      const height = img.clientHeight;

      const heatmap = h337.create({
        container,
        radius: 30,
        maxOpacity: 0.9,
        minOpacity: 0.1,
        blur: 0.75,
        gradient: {
          0.0: "blue",
          0.4: "purple",
          0.6: "orange",
          0.9: "red",
          1.0: "yellow",
        },
      });

      const bucketedShots: { [key: string]: number } = {};
      shots.forEach((s) => {
        const key = `${Math.round(s.x)}-${Math.round(s.y)}`;
        bucketedShots[key] = (bucketedShots[key] || 0) + 1;
      });

      const formattedData = Object.entries(bucketedShots).map(([key, count]) => {
        const [x, y] = key.split("-").map(Number);
        return {
          x: (x / 100) * width,
          y: (y / 100) * height,
          value: count,
        };
      });

      const maxValue = Math.max(...formattedData.map((d) => d.value), 1);

      heatmap.setData({
        max: maxValue,
        data: formattedData,
      });
    };

    if (img.complete) {
      onLoad(); // déjà chargée
    } else {
      img.addEventListener("load", onLoad);
      return () => img.removeEventListener("load", onLoad);
    }
  }, [shots]);

  return (
    <div
      ref={containerRef}
      className="relative w-full max-w-3xl mx-auto"
    >
      <img
        ref={imgRef}
        src="/court.png"
        alt="Terrain"
        className="w-full h-auto block select-none"
      />
    </div>
  );
};
